export const TELEGRAM_INTERNAL_DEFAULT_CATEGORIES = [
  {
    id: 'deposit',
    name: 'Deposit',
    keywords: ['deposit', 'dep'],
    ownerAgentId: null,
  },
  {
    id: 'withdraw',
    name: 'Withdraw',
    keywords: ['withdraw', 'wd'],
    ownerAgentId: null,
  },
  {
    id: 'membership',
    name: 'Membership',
    keywords: ['register', 'member', 'สมัคร'],
    ownerAgentId: null,
  },
];

export const normalizeText = value =>
  String(value || '')
    .trim()
    .toLowerCase();

export const parseKeywords = raw =>
  String(raw || '')
    .split(',')
    .map(token => token.trim())
    .filter(Boolean);

export const stringifyKeywords = keywords => (keywords || []).join(', ');

export const readJSONStorage = (key, fallback = null) => {
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch (error) {
    return fallback;
  }
};

export const writeJSONStorage = (key, payload) => {
  window.localStorage.setItem(key, JSON.stringify(payload));
};

export const findMatchedCategory = (content, categories = []) => {
  const text = normalizeText(content);
  if (!text) return null;

  return categories.find(category =>
    (category.keywords || []).some(keyword =>
      text.includes(normalizeText(keyword))
    )
  );
};
